import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { ROUTES } from '../constants';

interface LocationState {
  from?: {
    pathname: string;
  };
}

export const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, initialized } = useAppSelector((state) => state.user);
  const location = useLocation();

  if (!initialized) {
    return null; // or a loading spinner
  }

  if (currentUser) {
    // Redirect to the page they came from, or home if no previous location
    const from = (location.state as LocationState)?.from?.pathname || ROUTES.HOME;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
